export default __webpack_public_path__ + "static/media/personprojectimg.1c0a0b63.png";